import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ConsultationService, AppService, DialogService, VisiteService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'

const KEY = 'visite-dialog'

@Component({
	selector: 'atyl-visite-dialog',
	templateUrl: './visite-dialog.component.html',
	styleUrls: ['./visite-dialog.component.scss']
})
@Stringable({
	path: 'views/partials/layout/dialogs/visite-dialog',
	key: KEY,
})
export class VisiteDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY)
  	strings: any;
	
	options:any = [];
	selectedEtat:any;

	constructor(
		public dialogRef: MatDialogRef<VisiteDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private appService: AppService,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		private visiteService: VisiteService,
		public dialog: MatDialog
	 
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		this.dialogRef.updateSize("390px","200px")
	}

	displayAutoSelectListInstru(key?: any): string | undefined {
		let selected
		if (this.data.etats) {
			this.data.etats.forEach((select) => {
				if (key && select.ID === key.ID)
					selected = select
			})
		}
		return selected ? selected.libelle : undefined
	}

	UpdateVisite(){
		let toConfirm = true;
		let nbVisite:any = this.data.donnees.visite.length;
		let selectedEtat = this.selectedEtat.libelle;
		
		if(toConfirm == true){
			const confDialogRef = this.dialog.open(ConfirmComponent, {
				data : {
					libelle : "Etes-vous sûr de vouloir modifier "+nbVisite+" consultation(s) et de les affecter à l'état "+ selectedEtat
				}
			});
			confDialogRef.afterClosed().subscribe(res => {
				if(res === "true"){ 
					let dataReturn = {
						etat:this.selectedEtat
					}
					this.dialogRef.close(dataReturn);
				} else {
					console.log("Aucun etat selectionné")
				}		
			})
		}
	}

}
